export default (url) => {
return fetch(url)
  .then(function(response) {
    return response.json();
  })
}
